import { DateTime } from "luxon";

import { TIMEZONE } from "../constants/constants";
import { normalizeTimeZoneOffset } from "./date/normalizeTimeZoneOffset";

export function getTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getDateTimeInTargetTimeZone(date: string, timeZone?: string) {
  // 브라우저에서 사용자의 타임존 정보 가져오기
  const targetTimeZone = timeZone || getTimezone();

  const dateTimeUtc = DateTime.fromISO(date, { zone: TIMEZONE.UTC });
  return dateTimeUtc.setZone(normalizeTimeZoneOffset(targetTimeZone));
}

// 현재 프로젝트에서는 사용 안함
export function getDayOfWeekFromUtc(
  utcDateString: string,
  timeZone?: string
): string {
  // UTC 날짜를 로컬 타임존으로 변환
  const localDateTime = getDateTimeInTargetTimeZone(utcDateString, timeZone);

  // 요일을 얻음. DateTime 객체가 유효하지 않으면 대체 문자열 반환
  return localDateTime.weekdayLong ?? "Invalid Date";
}
